<script>
import { formatMonto } from "@/utils";

export default {
  name: "ColorTypeInvoiceByClient",
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  functional: true,

  render(createElement, context) {
    let { rowValue } = context.data.attrs;
    let { column } = context.data.attrs;
    let { row } = context.props;
    let Type = "Celeste";
    let Status;
    if (rowValue != 0) {
      Status = rowValue;
    }
    switch (column) {
      case "January":
        break;
      case "February":
        if (rowValue < row.January) {
          Type = "Rojo";
        }
        break;
      case "March":
        if (rowValue < row.February) {
          Type = "Rojo";
        }
        break;
      case "April":
        if (rowValue < row.March) {
          Type = "Rojo";
        }
        break;
      case "May":
        if (rowValue < row.April) {
          Type = "Rojo";
        }
        break;
      case "June":
        if (rowValue < row.May) {
          Type = "Rojo";
        }
        break;
      case "July":
        if (rowValue < row.June) {
          Type = "Rojo";
        }
        break;
      case "August":
        if (rowValue < row.July) {
          Type = "Rojo";
        }
        break;
      case "September":
        if (rowValue < row.August) {
          Type = "Rojo";
        }
        break;
      case "October":
        if (rowValue < row.September) {
          Type = "Rojo";
        }
        break;
      case "November":
        if (rowValue < row.October) {
          Type = "Rojo";
        }
        break;
      case "December":
        if (rowValue < row.November) {
          Type = "Rojo";
        }
        break;
      default:
        break;
    }
    return createElement(
      "b",
      {
        attrs: {
          name: "",
          class: Type
        }
      },
      Status ? formatMonto(Status) : null
    );
  }
};
</script>
<style scoped>
.Rojo {
  color: rgba(255, 0, 0, 0.712);
}
.Celeste {
  color: #5f8fdf;
}
</style>
